import React, { useState, useRef } from "react";
import logo from "../../../../assets/images/LOGO.png";
import { useNavigate } from "react-router-dom";
import { validatePassword } from "../../../../utility/helper";
import { Toast } from "primereact/toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { updatePassword } from "../../../../services/auth/signIn";
import { useDispatch } from "react-redux";
import { fetchUserRole } from "../../../../redux/userSlice";
import { IoMdArrowBack } from "react-icons/io";

const PasswordChange = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const toast = useRef(null);
  const accessToken = JSON.parse(localStorage.getItem("access_token"));

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleInputChange = (field, setter) => (e) => {
    setter(e.target.value);
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ oldPassword: "", newPassword: "", confirmPassword: "" });

    let formIsValid = true;

    if (!oldPassword) {
      setErrors((prev) => ({
        ...prev,
        oldPassword: "Old password is required",
      }));
      formIsValid = false;
    }

    if (!newPassword) {
      setErrors((prev) => ({
        ...prev,
        newPassword: "New password is required",
      }));
      formIsValid = false;
    } else if (!validatePassword(newPassword)) {
      setErrors((prev) => ({
        ...prev,
        newPassword:
          "Password must be at least 8 characters long, include at least one uppercase letter, one number, and one special character",
      }));
      formIsValid = false;
    } else if (newPassword === oldPassword) {
      setErrors((prev) => ({
        ...prev,
        newPassword: "New password cannot be the same as the old password",
      }));
      formIsValid = false;
    }

    if (!confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmPassword: "Confirm password is required",
      }));
      formIsValid = false;
    } else if (newPassword !== confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmPassword: "confirm Passwords do not match with New password",
      }));
      formIsValid = false;
    }

    if (formIsValid) {
      setLoading(true);
      try {
        const response = await updatePassword(
          oldPassword,
          newPassword,
          accessToken
        );

        if (response.status === 200 && response.data.status === true) {
          await dispatch(fetchUserRole(accessToken)).unwrap();
          navigate("/");
        }
      } catch (error) {
        console.error("Error during password update:", error.message);
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: error.message,
          life: 3000,
        });
        setErrors((prev) => ({
          ...prev,
          oldPassword: "Password update failed. Please check your credentials.",
        }));
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-primary relative">
      <Toast ref={toast} />
      <div className="absolute top-1 left-4">
        <img src={logo} alt="App Icon" className="w-[4.5rem]" />
      </div>
      <div className="flex flex-col items-center min-h-screen">
        <div className="text-white text-start p-8 space-y-6 mt-12">
          <h1 className="text-2xl text-amber-50">
            Secure your wealth, grow your future
          </h1>
          <span className="text-xl mb-32 text-amber-50 mt-10 text-center flex justify-center">
            Update Password
          </span>
          <form className="max-w-sm mx-auto" onSubmit={handleSubmit}>
            <div className="mb-5 relative">
              <input
                type={showOldPassword ? "text" : "password"}
                id="old-password"
                value={oldPassword}
                onChange={handleInputChange("oldPassword", setOldPassword)}
                onKeyDown={handleKeyDown}
                className="bg-transparent border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                placeholder="Old Password"
                required
              />
              <button
                type="button"
                onClick={() => setShowOldPassword(!showOldPassword)}
                className="absolute right-3 top-3 text-lg text-gray-500"
              >
                {showOldPassword ? (
                  <FaEye className="text-secondary" />
                ) : (
                  <FaEyeSlash />
                )}
              </button>
              {errors.oldPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.oldPassword}
                </p>
              )}
            </div>
            <div className="mb-5 relative">
              <input
                type={showNewPassword ? "text" : "password"}
                id="new-password"
                value={newPassword}
                onChange={handleInputChange("newPassword", setNewPassword)}
                onKeyDown={handleKeyDown}
                className="bg-transparent border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                placeholder="New Password"
                required
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="absolute right-3 top-3 text-lg text-gray-500"
              >
                {showNewPassword ? (
                  <FaEye className="text-secondary" />
                ) : (
                  <FaEyeSlash />
                )}
              </button>
              {errors.newPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.newPassword}
                </p>
              )}
            </div>
            <div className="mb-5 relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirm-password"
                value={confirmPassword}
                onChange={handleInputChange(
                  "confirmPassword",
                  setConfirmPassword
                )}
                onKeyDown={handleKeyDown}
                className="bg-transparent border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                placeholder="Confirm Password"
                required
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-3 text-lg text-gray-500"
              >
                {showConfirmPassword ? (
                  <FaEye className="text-secondary" />
                ) : (
                  <FaEyeSlash />
                )}
              </button>
              {errors.confirmPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.confirmPassword}
                </p>
              )}
            </div>
            <button
              type="submit"
              className={`w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              {loading ? "Loading..." : "Submit"}
            </button>
            <button
              className="w-full text-white bg-transparent focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center"
              onClick={handleBack}
            >
              <IoMdArrowBack size={14} className="mr-2" />
              Go Back
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordChange;
